import { Component } from '@angular/core';
import { ModalContent } from './modal-content.component';

@Component({
    selector: 'standard-modal',
    template: require('./standard-modal.component.html')
})
export class StandardModal extends ModalContent {

    public onAcceptClicked(event: Event): void {
        this.TryEmitCallBackEvent(this.modalOptions.onOkClickedCallBack, event);
        this.TryEmitCallBackEvent(this.modalOptions.onBeforeModalClose, event);
        this.modalDialogInfo.close();
    }

    public onCancelClicked(event: Event): void {
        this.TryEmitCallBackEvent(this.modalOptions.onCancelClickedCallBack, event);
        this.TryEmitCallBackEvent(this.modalOptions.onBeforeModalClose, event);
        this.modalDialogInfo.close();
    }

    public onDismissModal(event: Event): void {
        this.TryEmitCallBackEvent(this.modalOptions.onBeforeModalClose, event);
        this.modalDialogInfo.dismiss();
    }

    private TryEmitCallBackEvent(func: Function, event: Event): void {
        if (func) {
            func(event);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/standard-modal.component.ts